import { ComponentProps } from 'react';

import Text from '../Text/Text';

import styles from './RichText.module.css';

type RichTextProps = { html?: string } & Omit<
    ComponentProps<typeof Text>,
    'children'
>;

const RichText = ({ html, ...textProps }: RichTextProps) => {
    return (
        <Text {...textProps} tag="div" className={styles.Root}>
            <span dangerouslySetInnerHTML={{ __html: html ?? '' }} />
        </Text>
    );
};

export default RichText;
